// @flow

import * as React from "react";
import { FetcherUrl } from "../../Fetchers/FetcherUrl";
import { DictionaryStore } from "./DictionaryStore";
const _conn = new FetcherUrl();
const dictionaryStore = new DictionaryStore(_conn, '');
export const DictionaryStoreCtx: React$Context<DictionaryStore> = React.createContext<DictionaryStore>(dictionaryStore);
